<template>
  <div id="app" ref="app">
    <global-nav></global-nav>
    <global-nav-pc></global-nav-pc>
    <div class="view">
      <router-view />
    </div>
    <footer-bar
      :class="this.$route.path !== '/contact' ? 'mt-5 pt-5' : 'd-none'"
    ></footer-bar>
  </div>
</template>

<script>
import GlobalNav from "@/components/GlobalNav";
import GlobalNavPc from "@/components/GlobalNavPc";
import FooterBar from "@/components/FooterBar";

export default {
  components: {
    GlobalNav,
    GlobalNavPc,
    FooterBar,
  },
  methods: {
    init() {
      this.$firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          this.$store.commit("setUser", user);
          if (user.uid) {
            console.log(user.email, "으로 로그인하였습니다");
            this.$router.push("/admin");
          }
        } else {
          // ...
        }
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss">
.view {
  @media all and (max-width: 1280px) {
    margin-top: 5rem !important;
  }
  @media all and (min-width: 1280px) {
    margin-top: 94.5px !important;
  }
}
#app {
  overflow: hidden;
}
</style>
